import React, { Component } from 'react'
import Carousel from 'nuka-carousel'
import Preview from './preview'


class Slider extends Component {

    render() {
        const wide = !!this.props.wide
        const images = this.props.images.map((image, key) => <Preview key={key} image={image} wide={wide}/>)
        console.log(images)
        return (
            this.props.video ?
                <video src={this.props.video} controls />
                :
                <Carousel slidesToShow={1} slidesToScroll={1} cellAlign='center' cellSpacing={30} slideWidth={wide ? '450px' : '200px'} initialSlideWidth={wide ? 450 : 200} easing='easeInOutQuad'>
                    {images}
                </Carousel>
        )
    }

}


export default Slider



// WEBPACK FOOTER //
// ./src/components/slider.js